const serializer = {
  // CAPI - `number` is `num` in CACA, they are separate functions so any future changes won't break either.
  // note: `fromServer` is called in markupSerializer since punchlists are returned there as well.
  fromServer: data => ({
    uid: data.uid,
    project: data.project,
    listId: data.issue_list_uid || "",
    issueList: data.issue_list,
    location: data.room,
    title: data.title,
    status: data.status,
    number: data.number,
    description: data.description,
    string: data.string,
    startDate: data.start_date || null,
    dueDate: data.due_at || null,
    issueType: data.issue_type,
    assignedTo: data.assigned_to || "",
    hasCostImpact: data.has_cost_impact,
    costImpact: data.cost_impact || null,
    hasScheduleImpact: data.has_schedule_impact,
    scheduleImpact: data.schedule_impact || null,
    assignees: data.assignees,
    followers: data.followers,
    photos: data.photos,
    createdAt: data.created_at ? data.created_at.$date : null,
    createdBy: data.created_by,
    annotation: data.annotation,
    deleted: data.deleted,
    archived: data.archived,
    stampBased: data.stamp_based,
    numComments: data.num_comments,
    rootCauseUid: data.root_cause_uid || null,
  }),
  fromCACA: data => ({
    ...serializer.fromServer(data),
    number: data.num,
  }),
  // CACA
  createStampFromServer: data => ({
    ...data,
    punch: serializer.fromCACA(data.punch),
  }),
  /**
   * Returns issue data formatted for sending to cacahuete.
   *
   * @param {object} data - frontend issue object, or partial issue object
   *      This likely was created by deserializing from a cacahuete response at some point.
   * @return {object} - issue data for sending to the cacahuete API
   */
  toServer: data => {
    const { stampBased, archived, hasCostImpact, hasScheduleImpact } = data;
    return {
      has_cost_impact:
        hasCostImpact !== undefined ? !!hasCostImpact : hasCostImpact,
      cost_impact: data.costImpact,
      has_schedule_impact:
        hasScheduleImpact !== undefined
          ? !!hasScheduleImpact
          : hasScheduleImpact,
      schedule_impact: data.scheduleImpact,
      stamp_based: stampBased !== undefined ? !!stampBased : stampBased,
      uid: data.uid,
      issue_list_uid: data.issueList ? data.issueList.uid : data.listId,
      title: data.title,
      status: data.status,
      room: data.location,
      start_date: data.startDate,
      due_at: data.dueDate,
      issue_type: data.issueType,
      description: data.description,
      photos: data.photos,
      assignees: data.assignees,
      followers: data.followers,
      string: data.string,
      archived: archived !== undefined ? !!archived : archived,
      root_cause_uid: data.rootCauseUid,
    };
  },
};
export default serializer;
